import { render, staticRenderFns } from "./InvoiceDocument.vue?vue&type=template&id=4233f864&scoped=true&lang=pug&"
import script from "./InvoiceDocument.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDocument.vue?vue&type=script&lang=ts&"
import style0 from "./InvoiceDocument.vue?vue&type=style&index=0&id=4233f864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4233f864",
  null
  
)

export default component.exports